"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PadWidget = void 0;
const button_1 = require("client/components/material/button");
const store_1 = require("client/modules/pads/store");
const edit_pads_1 = require("client/modules/sites/modules/sites-detail/components/edit-pads");
const store_2 = require("client/modules/sites/modules/sites-detail/store");
const store_3 = require("client/modules/users/store");
const React = require("react");
const react_1 = require("react");
require("./pad-widget.less");
class PadsDetail extends react_1.Component {
    render() {
        const siteId = Number(store_3.usersStore.user.value.siteId);
        return (React.createElement("div", { className: "sites__form", onMouseDown: e => e.stopPropagation() },
            React.createElement(edit_pads_1.EditPads, { error: store_2.sitesDetailStore.site.error, loading: store_2.sitesDetailStore.site.loading, onCancel: () => alert("cancel clicked"), site: siteId ? store_2.sitesDetailStore.site.value : null, noSearchFilter: true })));
    }
}
exports.PadWidget = (props) => (React.createElement("div", { className: "pad-widget widget" },
    React.createElement("div", { className: "pad-widget__content" }, store_3.usersStore.permissions.ReadPads ? (React.createElement(React.Fragment, null,
        React.createElement("header", { className: "pad-widget__actions" },
            React.createElement("a", { href: "/pad", target: "_blank" },
                React.createElement(button_1.MaterialButton, { flat: true, primary: true, onClick: () => {
                        store_1.padsStore.resetPadCache();
                    } }, "Create Pad"))),
        React.createElement("div", { className: "pad-widget__pad" },
            React.createElement(PadsDetail, null)))) : (store_3.usersStore.showLock()))));



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/modules/widget-grid/components/pad-widget/pad-widget.tsx
// module id = 3357
// module chunks = 0